import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { registerLocaleData } from '@angular/common';

import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeCy from '@angular/common/locales/cy';
import localePt from '@angular/common/locales/pt';
import localeMs from '@angular/common/locales/ms';
import localeId from '@angular/common/locales/id';
import localeTh from '@angular/common/locales/th';
import localeSw from '@angular/common/locales/sw';
import localeFil from '@angular/common/locales/fil';
import localeHi from '@angular/common/locales/hi';
import localeTa from '@angular/common/locales/ta';
// import localeAr from '@angular/common/locales/ar';

/** A Language interface */
export interface Language
{
    name: string;
    code: string;
    flag: string;
    dir: string;
    live: boolean;
}


/** The service that handles the languages that spotter can use */
@Injectable({ providedIn: 'root' })
export class LanguageService {

	languages: Array<Language> = new Array<Language>();
    language: Language;

	/** Create the list of available languages */
	constructor(public translate: TranslateService)
	{
        this.languages.push({name: "English", code: "en", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Cymraeg", code: "cy", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Français", code: "fr", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Português", code: "pt", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Español", code: "es", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Bahasa Melayu", code: "my", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Bahasa Indonesia", code: "id", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Swahili", code: "sw", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Tetun", code: "tet", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "Tagalog", code: "tl", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "แบบไทย", code: "th", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "தமிழ்", code: "ta", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "हिन्दी", code: "hi", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "മലയാളം", code: "ml", flag: "", dir: "ltr", live: true});
        this.languages.push({name: "فارسی", code: "fa", flag: "", dir: "rtl", live: true});
        this.languages.push({name: "العربية", code: "ar", flag: "", dir: "rtl", live: true});


        let l = window.localStorage.getItem("language");
        //let l = "en";
        if (l == null)
        {
            let lang = this.translate.getBrowserLang();
            if (lang)
                l = lang;
            else
                l = "en";
        }
        this.language = this.getLanguageFromCode(l);

        // Update HTML language attributes
        document.getElementsByTagName('html')[0].setAttribute('dir', this.language.dir); 
        document.getElementsByTagName('html')[0].setAttribute('lang', this.language.code); 

	}

    registerAndLoadLanguage(): string
    {
        switch (this.language.code)
        {
            case 'en': {
                registerLocaleData(localeEn, this.language.code);
                break;
            }
            // case 'ar': {
            //     registerLocaleData(localeAr, this.language.code);
            //     break;
            // }
            case 'fr': {
                registerLocaleData(localeFr, this.language.code);
                break;
            }
            case 'cy': {
                registerLocaleData(localeCy, this.language.code);
                break;
            }
            case 'pt': {
                registerLocaleData(localePt, this.language.code);
                break;
            }
            case 'my': {
                registerLocaleData(localeMs, 'ms');     //TODO: Rename using correct country code
                 return 'ms';
                 break;
            }
            case 'id': {
                registerLocaleData(localeId, this.language.code);
                break;
            }
            case 'th': {
                registerLocaleData(localeTh, this.language.code);
                break;
            }
            case 'sw': {
                registerLocaleData(localeSw, this.language.code);
                break;
            }

            case 'tl': {
                registerLocaleData(localeFil, 'fil');     //TODO: Rename using correct country code
                return 'fil';
                break;
            }
            case 'hi': {
                registerLocaleData(localeHi, this.language.code);
                break;
            }
            case 'ta': {
                registerLocaleData(localeTa, this.language.code);
                break;
            }

            default: {
                console.error("Unknown langauge");
                
                registerLocaleData(localeEn, 'en');
                return "en";
            }
        }
        
        return this.language.code
    }


    /** Gets all the available languages */
    getLanguages() : Array<Language>
    {
        return this.languages;
    }

    /** Gets a language's name from its two or three letter ISO code */
    getLanguageNameFromCode(code: string) : string
    {
        let name = "Language Error";
        this.languages.forEach(l => {
            if (l.code == code)
                name = l.name;
        });

        return name;
    }

    getLanguageFromCode(code: string) : Language
    {
        let lan = this.languages[0];
        this.languages.forEach(l => {
            if (l.code == code)
                lan = l
        });

        return lan;
    }

}
